import React from 'react';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {hot} from 'react-hot-loader/root';
import {
    AddUser,
    CorporateProjects,
    Home,
    ListOfProjects,
    ListOfUsers,
    MyProjects,
    Profile,
    Project,
    SignIn,
    ResetPassword,
    ForgotPassword,
    AddCompany,
    RenewPassword,
    EditCompany,
    EditUser
} from "./screens"
import {ThemeProvider} from '@material-ui/core';
import theme from './theme';
import RouteSecured from './security/RouteSecured';
import {ToastContainer} from "react-toastify";

//console.log = ()=>{};

function App() {
    return (
        <>
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route exact path="/signIn" element={<SignIn/>}/>
                    <Route exact path="/" element={<RouteSecured><Home/></RouteSecured>}/>
                    <Route exact path="/forgotPassword" element={<ForgotPassword/>}></Route>
                    <Route exact path="/resetPassword/:token" element={<ResetPassword/>}></Route>
                    <Route exact path="/resetPassword/" element={<ResetPassword/>}></Route>

                    <Route path="/home" element={<RouteSecured><Home/></RouteSecured>}/>
                    <Route path="/project"
                           element={<RouteSecured><Project/></RouteSecured>}/>
                    <Route path="/corporateProjects"
                           element={<RouteSecured><CorporateProjects/></RouteSecured>}/>
                    <Route path="/listOfProjects"
                           element={<RouteSecured><ListOfProjects/></RouteSecured>}/>
                    <Route path="/listOfUsers"
                           element={<RouteSecured><ListOfUsers/></RouteSecured>}/>
                    <Route path="/profile"
                           element={<RouteSecured><Profile/></RouteSecured>}/>
                    <Route path="/renewPassword"
                           element={<RouteSecured><RenewPassword/></RouteSecured>}/>
                    <Route path="/addUser"
                           element={<RouteSecured><AddUser/></RouteSecured>}/>
                    <Route path="/editUser"
                           element={<RouteSecured><EditUser/></RouteSecured>}/>
                    <Route path="/addCompany"
                           element={<RouteSecured><AddCompany/></RouteSecured>}/>
                    <Route path="/editCompany"
                           element={<RouteSecured><EditCompany/></RouteSecured>}/>
                    <Route path="/yourProjects"
                           element={<RouteSecured><MyProjects/></RouteSecured>}/>
                </Routes>
            </Router>
        </ThemeProvider>
        <ToastContainer
            position="bottom-left"
            autoClose={10000}/>
        </>
    );
}

export default hot(App);
